import React, { createContext, useContext, useEffect, useState } from "react";
import SearchCommand from "../components/SearchCommand";

const SearchContext = createContext({ openSearch: () => {} });

export const SearchProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      // Cmd+K (Mac) or Ctrl+K (Windows/Linux)
      if ((e.metaKey || e.ctrlKey) && (e.key === "k" || e.key === "K")) {
        e.preventDefault();
        setOpen((prev) => !prev);
      } else if (e.key === "/" && !["INPUT", "TEXTAREA"].includes((e.target?.tagName || ""))) {
        // "/" hotkey too — common on trading sites
        e.preventDefault();
        setOpen(true);
      }
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, []);

  return (
    <SearchContext.Provider value={{ openSearch: () => setOpen(true) }}>
      {children}
      <SearchCommand open={open} setOpen={setOpen} />
    </SearchContext.Provider>
  );
};

export const useSearch = () => useContext(SearchContext);
